import { IonButton, IonIcon, IonText } from "@ionic/react";
import { lockClosed } from "ionicons/icons";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "../constants/urls";
import { useIsPro, useSubscription } from "./hooks";
import "./SubscriptionExpired.css";

export const SubscriptionExpired: FC = () => {
    const { t } = useTranslation();
    const isPro = useIsPro();
    const subscription = useSubscription();

    // Don't show until subscription state has been loaded
    if (!subscription?.updatedAt) return null;
    if (isPro) return null;

    return (
        <div className="subscription-expired-overlay" data-testid="subscription-expired">
            <div className="subscription-expired-content">
                <IonIcon icon={lockClosed} className="subscription-expired-icon" />
                <IonText>
                    <h2>{t("accountNotification.subscriptionExpired.title")}</h2>
                </IonText>
                <IonButton
                    href={`mailto:${SUPPORT_EMAIL}`}
                    expand="block"
                    className="subscription-expired-button"
                >
                    {t("accountNotification.subscriptionExpired.contactSupport")}
                </IonButton>
            </div>
        </div>
    );
};
